import React, { useState, useCallback, useRef, useEffect } from "react";
import ReactDOM from "react-dom";
import Modal from "react-bootstrap/Modal";
import { Button, Slider } from "antd";
import { CloseOutlined, CheckOutlined } from "@ant-design/icons";
import Camera from "../desktopCamera/desktopCamera";
import VideoCamera from "../desktopCamera/desktopVideo";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { getBase64Image } from "../../utils";
import Cropper from "react-easy-crop";
import styled, { css } from "styled-components";
import { closePhoto, openPhoto } from "../login/userSession.redux";
import { validateValue } from "../../utils/utils";
import { AutoComplete } from "antd";
import {
  CameraFill,
  Image as BootstrapImage,
  Crop,
  XSquareFill,
  Badge3d,
  Badge3dFill,
  CameraVideoFill,
  Images,
  Plus,
  Trash,
  ChevronRight,
} from "react-bootstrap-icons";

const CropperContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999999;
  width: 100%;
  height: 100%;
`;

const AutoCompleteTag = styled(AutoComplete)`
  width: 100%;
  height: 48px;

  & .ant-select-selector {
    height: 48px !important;
    overflow: visible !important;
    border-radius: 4px !important;
  }

  &.arsenal-select .ant-select-selector {
    overflow: auto;
    padding-top: 2px;
  }

  &.arsenal-select .ant-select-selector .ant-select-selection-item {
    line-height: 48px !important;
  }

  &.arsenal-select
    .ant-select-selector
    .ant-select-selection-overflow-item
    .ant-select-selection-item {
    line-height: 24px !important;
  }
`;

const CropperButtons = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 10px;
  height: 75px;
`;

const ZoomSlider = styled(Slider)`
  & .ant-slider-handle {
    border-color: #00147b;
  }

  & .ant-slider:hover .ant-slider-track {
    background-color: #00147b !important;
  }

  & .ant-slider-track {
    background-color: #00147b !important;
  }
`;

const ButtonAdd = styled.button`
  background: #00297a 0% 0% no-repeat padding-box;
  border-color: #00297a;
  border-radius: 10px;
  margin-top: 20px;
  opacity: 1;
  width: 150px;
  height: 48px;
  font-weight: 500;
  color: #ffffff;

  &:hover {
    background: #00187e;
    border-color: #00187e;
  }
  @media (max-width: 768px) {
    margin-top: 10px;
  }
`;
const SectionLayoutType = styled.div`
  background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
  border: 1px solid var(--unnamed-color-d4d4d5);
  background: #ffffff 0% 0% no-repeat padding-box;
  opacity: 1;
  width: 130px;

  ${(props) =>
    props.primary &&
    css`
      width: auto;
    `}
  ${(props) =>
    props.big &&
    css`
      width: auto;
    `}
`;
const ButtonImagetype = styled.button`
  display: inline-block;
  margin: 0.5rem 0;
  width: 52px;
  height: 55px;
  background: "#E0E1E2";
  color: "#00000099";
  border: 2px solid white;
  font: normal normal 600 12px/18px Poppins;
  font-weight: 700;
  text-align: center;
  padding: 0;
  vertical-align: bottom;
  ${(props) =>
    props.left &&
    css`
      border-radius: 8px 0px 0px 8px;
      margin: 0.5rem 0;
    `}
  ${(props) =>
    props.right &&
    css`
      border-radius: 0px 8px 8px 0px;
      margin: 0.5rem 0.01rem;
      width: 53px;
    `}

    @media (max-width: 500px) {
    width: 40px;
    height: 45px;
  }
`;

const ImagePreview = (props) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [cropSize, setCropSize] = useState({ width: 0, height: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedArea, setCroppedArea] = useState(null);
  const [mediaSize, setMediaSize] = useState(null);
  const containerRef = useRef(null);
  const imageRef = useRef(null);
  const {
    imagePreview,
    imageExtension,
    setOpenPreview,
    setImagePreview,
    setImageExtension,
    setSrc,
    setTagExtension,
    setTagSetter,
    setTagPhoto,
    setTagVideo,
    isMobile,
    isTablet,
    isPortrait,
    closePhoto,
  } = props;

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedArea(croppedAreaPixels);
  }, []);

  useEffect(() => {
    if (containerRef.current) {
      setCropSize({
        width: isPortrait
          ? containerRef.current.offsetWidth * 0.9
          : containerRef.current.offsetWidth * 0.45,
        height: isPortrait
          ? containerRef.current.offsetWidth * 0.9
          : containerRef.current.offsetWidth * 0.45,
      });
    }
  }, [containerRef]);

  return ReactDOM.createPortal(
    <CropperContainer ref={containerRef}>
      <Cropper
        image={imagePreview}
        crop={crop}
        zoom={zoom}
        cropSize={cropSize}
        aspect={1}
        onCropChange={setCrop}
        onZoomChange={setZoom}
        onCropComplete={onCropComplete}
        cropShape={props.circle ? "round" : "rect"}
        setImageRef={(ref) => (imageRef.current = ref.current)}
        setMediaSize={(size) => setMediaSize(size)}
      />
      <CropperButtons>
        <div
          style={{
            width: "200px",
            color: "white",
            marginRight: "1em",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <ZoomSlider
            min={1}
            max={3}
            onChange={(value) => setZoom(value)}
            value={zoom}
            step={0.1}
          />
        </div>
        <Button
          type="primary"
          danger
          shape="circle"
          size="large"
          onClick={() => {
            setImagePreview(null);
            setImageExtension(null);
            setOpenPreview(false);
            closePhoto();
            if (window) window.takingPhoto = false;
          }}
          style={{ marginRight: "1em" }}
        >
          <CloseOutlined style={{ fontSize: 16, verticalAlign: 0 }} />
        </Button>
        <Button
          type="primary"
          shape="circle"
          size="large"
          onClick={async () => {
            const { realData } = await getBase64Image(
              imagePreview,
              imageRef.current.offsetWidth,
              imageRef.current.offsetHeight,
              isPortrait
                ? containerRef.current.offsetWidth * 0.9
                : containerRef.current.offsetWidth * 0.45,
              props.circle,
              crop.x,
              crop.y,
              Math.round(zoom * 10) / 10,
              1,
            );
            // This preview/cropper is only reached from the desktop camera
            // flow, but both onFromCamera and onFromGallery are forwarded via
            // {...props}. Calling both adds the photo twice (bug 765), so only
            // fire one — camera takes precedence.
            if (props.includeTag) {
              if (props.onFromCamera) {
                props.setSrc(realData);
                props.setTagExtension(imageExtension);
                props.setTagSetter(true);
                props.setTagPhoto(true);
              } else if (props.onFromGallery) {
                props.setSrc(realData);
                props.setTagExtension(imageExtension);
                props.setTagSetter(true);
                props.setTagGallery(true);
              }
            } else {
              if (props.onFromCamera) {
                props.onFromCamera(realData, imageExtension);
              } else if (props.onFromGallery) {
                props.onFromGallery(realData, imageExtension);
              }
            }
            setImagePreview(null);
            setImageExtension(null);
            setOpenPreview(false);
            console.log("Props available: ", props);
            closePhoto();
            if (window) window.takingPhoto = false;
          }}
          style={{
            marginRight: "1em",
            backgroundColor: "#00147b",
            borderColor: "#00147b",
          }}
        >
          <CheckOutlined style={{ fontSize: 16, verticalAlign: 0 }} />
        </Button>
      </CropperButtons>
    </CropperContainer>,
    document.body
  );
};

export const FileUploader = (props) => {
  const [openPreview, setOpenPreview] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const [imageExtension, setImageExtension] = useState(null);

  // Create a reference to the hidden file input element
  const hiddenFileInput = React.useRef(null);

  // Programatically click the hidden file input element
  // when the Button component is clicked
  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };

  // Pass the handleClick function to the parent via the onTriggerClick prop
  useEffect(() => {
    console.log(props.onTriggerClick);
    if (props.onTriggerClick) {
      props.onTriggerClick(() => handleClick);
    }
  }, [props.onTriggerClick]);

  const handleChange = (event) => {
    const fileUploaded = event.target.files[0];
    const extension = fileUploaded.name.split(".").pop();

    const isImage = ["jpg", "jpeg", "png"].includes(extension);

    var reader = new FileReader();
    reader.readAsDataURL(fileUploaded);
    reader.onload = function () {
      if (props.includeTag) {
        if (props.onFromGallery) {
          props.setSrc(reader.result.split(";base64,")[1]);
          props.setTagExtension(isImage ? "png" : extension);
          props.setTagSetter(true);
          props.setTagGallery(true);
        }
      } else {
        if (props.circle) {
          setImagePreview(reader.result);
          setImageExtension(isImage ? "png" : extension);
          setOpenPreview(true);
        } else {
          props.onFromGallery &&
            props.onFromGallery(
              reader.result.split(";base64,")[1],
              isImage ? "png" : extension,
            );
        }
      }
    };
    reader.onerror = function (error) {
      console.error("Error: ", error);
    };
  };

  return (
    <>
      <Button
        style={{
          background: "none",
          fontSize: 12,
          border: "none",
          margin: 10,
          boxShadow: "none",
          ...props.style,
        }}
        onClick={handleClick}
      >
        {props.label}
      </Button>
      <input
        type="file"
        ref={hiddenFileInput}
        onChange={handleChange}
        style={{ display: "none" }}
        // Defaults to photos+video. Callers that want something else
        // (the spec sheet scan takes PDFs) pass their own list.
        accept={props.accept || ".jpg, .jpeg, .png, .mov, .mp4"}
      />
      {props.circle && openPreview && (
        <ImagePreview
          imagePreview={imagePreview}
          imageExtension={imageExtension}
          setOpenPreview={setOpenPreview}
          setImagePreview={setImagePreview}
          setImageExtension={setImageExtension}
          closePhoto={closePhoto}
          {...props}
        />
      )}
    </>
  );
};

const MobileCamera = (props) => {
  const [openPreview, setOpenPreview] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const [imageExtension, setImageExtension] = useState(null);
  const { containerWidth, containerHeight, type } = props;

  // Create a reference to the hidden file input element
  const hiddenFileInput = React.useRef(null);

  // Programatically click the hidden file input element
  // when the Button component is clicked
  const handleClick = (event) => {
    if (type === "image") {
      hiddenFileInput.current.setAttribute("accept", "image/*");
    } else if (type === "video") {
      hiddenFileInput.current.setAttribute("accept", "video/*");
    }
    hiddenFileInput.current.click();
  };

  // Pass the handleClick function to the parent via onTriggerClick
  useEffect(() => {
    if (props.onTriggerClick) {
      props.onTriggerClick(() => handleClick);
    }
  }, [props.onTriggerClick]);

  // Call a function (passed as a prop from the parent component)
  // to handle the user-selected file
  const handleChange = (event) => {
    const fileUploaded = event.target.files[0];
    // iOS fires change with no file when the camera sheet is dismissed.
    if (!fileUploaded) {
      return;
    }
    const extension = fileUploaded.name.split(".").pop();

    // Fall back to the MIME type: an iOS camera capture can arrive with an
    // unexpected name/extension (e.g. HEIC), which the extension list misses.
    const mimeType = fileUploaded.type || "";
    const isImage =
      ["jpg", "jpeg", "png"].includes(extension) || mimeType.startsWith("image/");
    const isVideo =
      ["mov", "mp4"].includes(extension) || mimeType.startsWith("video/");

    var reader = new FileReader();
    reader.readAsDataURL(fileUploaded);
    reader.onload = function () {
      if (props.includeTag) {
        if (isImage && props.onFromCamera) {
          props.setSrc(reader.result.split(";base64,")[1]);
          props.setTagExtension(isImage ? "png" : extension);
          props.setTagSetter(true);
          props.setTagPhoto(true);
        } else if (isVideo && props.onFromVideo) {
          props.setSrc(reader.result);
          props.setTagExtension(isVideo ? extension : "mp4");
          props.setTagSetter(true);
          props.setTagVideo(true);
        }
      } else {
        if (isImage && props.circle) {
          setImagePreview(reader.result);
          setImageExtension(isImage ? "png" : extension);
          setOpenPreview(true);
        } else if (isImage) {
          // Non-circle image (e.g. a spec sheet attachment): send the capture
          // straight through. Previously this case fell through and the photo
          // was silently dropped, so "Take from Camera" did nothing (#826).
          props.onFromCamera &&
            props.onFromCamera(
              reader.result.split(";base64,")[1],
              isImage ? "png" : extension,
            );
        } else if (isVideo) {
          props.onFromVideo &&
            props.onFromVideo(reader.result, isVideo ? extension : "mp4");
        }
      }
    };
    reader.onerror = function (error) {
      console.error("Error: ", error);
    };
  };

  return (
    <>
      <Button
        style={{
          background: "none",
          display: props.display === false ? "none" : "inline-block",
          fontSize: 12,
          border: "none",
          margin: 10,
          boxShadow: "none",
          ...props.style,
        }}
        onClick={handleClick}
      >
        {props.label}
      </Button>
      <input
        type="file"
        ref={hiddenFileInput}
        onChange={handleChange}
        style={{ display: "none" }}
        capture="environment"
      />
      {props.circle && openPreview && (
        <ImagePreview
          imagePreview={imagePreview}
          imageExtension={imageExtension}
          setOpenPreview={setOpenPreview}
          setImagePreview={setImagePreview}
          setImageExtension={setImageExtension}
          closePhoto={closePhoto}
          {...props}
        />
      )}
    </>
  );
};

const StyledPhotoModal = styled(Modal)`
  .modal-content {
    background-color: #ffffff;
    box-shadow: inset 0 4px 0 ${(p) => p.theme.color.primary},
      0 0.5rem 1rem rgba(0, 0, 0, 0.15);
    border-radius: ${(p) => p.theme.radius.md};
    border: none;
  }
  .modal-header {
    border-bottom: 1px solid ${(p) => p.theme.color.border};
    padding: calc(${(p) => p.theme.spacing.md} + 4px)
      ${(p) => p.theme.spacing.md} ${(p) => p.theme.spacing.md};
  }
  .modal-body {
    padding: ${(p) => p.theme.spacing.md};
    overflow: visible;
  }
`;

const PhotoModalTitle = styled.span`
  font-family: ${(p) => p.theme.font.family};
  font-size: ${(p) => p.theme.font.sizeLg};
  font-weight: ${(p) => p.theme.font.weightSemibold};
  color: ${(p) => p.theme.color.primary};
  line-height: 1.2;
`;

const PhotoInfoCard = styled.div`
  background: ${(p) => p.theme.color.surfaceAlt};
  border-radius: ${(p) => p.theme.radius.md};
  padding: ${(p) => p.theme.spacing.md};
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 4px;
`;

// Shared look so every option row (camera / video / gallery) matches the
// PhotoOptionButton styling used by crop / delete — one uniform button size.
const optionButtonStyle = {
  width: "100%",
  background: "#ffffff",
  border: "1px solid #e5e7eb",
  borderRadius: 8,
  color: "#00187e",
  fontFamily: "Poppins, sans-serif",
  fontWeight: 600,
  fontSize: 14,
  padding: "10px 14px",
  boxShadow: "none",
  margin: 0,
  height: "auto",
  lineHeight: 1.2,
};

const PhotoOptionButton = styled(Button)`
  && {
    width: 100%;
    background: #ffffff;
    border: 1px solid ${(p) => p.theme.color.border};
    border-radius: ${(p) => p.theme.radius.md};
    color: ${(p) => p.theme.color.primary};
    font-family: ${(p) => p.theme.font.family};
    font-weight: 600;
    font-size: ${(p) => p.theme.font.sizeMd};
    padding: 10px 14px;
    box-shadow: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: auto;
    line-height: 1.2;
    margin: 0;
    transition: background 0.15s ease, border-color 0.15s ease;

    &:hover,
    &:focus {
      background: ${(p) => p.theme.color.surfaceAlt};
      border-color: ${(p) => p.theme.color.primary};
      color: ${(p) => p.theme.color.primary};
    }

    &.danger,
    &.danger:hover {
      color: #d33;
      border-color: #fdd;
    }
  }
`;

const PhotoSelectModal = (props) => {
  const [openPreview, setOpenPreview] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const [imageExtension, setImageExtension] = useState(null);
  const { t } = useTranslation();
  const {
    deviceInfo,
    circle,
    includeTag = false,
    containerWidth,
    containerHeight,
    setTagSetter,
    setSrc,
    setTagExtension,
    setTagPhoto,
    setTagVideo,
    setTagGallery,
  } = props;

  useEffect(() => {
    if (window) window.takingPhoto = false;
    if (props.show) {
      props.openPhoto();
      if (window) window.takingPhoto = true;
    }
  }, [props.show]);

  let currentPhotoExtension =
    props.currentPhoto && props.currentPhoto.indexOf("data:image/") > -1
      ? "png"
      : props.currentPhoto && props.currentPhoto.split(".").pop();

  return (
    <StyledPhotoModal
      {...props}
      size="sm"
      aria-labelledby="contained-modal-title-vcenter"
      dialogClassName="photoselect-popup"
      centered
      onClosed={() => {
        closePhoto();
        if (window) window.takingPhoto = false;
      }}
    >
      <Modal.Header closeButton>
        <PhotoModalTitle>
          {props.showTitle
            ? t("photoSelectModal.title")
            : t("photoSelectModal.title")}
        </PhotoModalTitle>
      </Modal.Header>
      <Modal.Body>
        <PhotoInfoCard>
        {!deviceInfo.isMobile && (
          <PhotoOptionButton onClick={() => props.setOpenCamera(true)}>
            {t("photoSelectModal.fromCamera")}
          </PhotoOptionButton>
        )}
        {!deviceInfo.isMobile && props.showVideo && (
          <PhotoOptionButton onClick={() => props.setOpenVideo(true)}>
            {t("photoSelectModal.fromVideo")}
          </PhotoOptionButton>
        )}
        {deviceInfo.isMobile && (
          <MobileCamera
            label={t("photoSelectModal.fromCamera")}
            onFromCamera={props.onFromCamera}
            circle={circle}
            containerWidth={containerWidth}
            containerHeight={containerHeight}
            type="image"
            isMobile={deviceInfo.isMobile}
            isTablet={deviceInfo.isTablet}
            isPortrait={deviceInfo.isPortrait}
            includeTag={includeTag}
            setSrc={setSrc}
            setTagSetter={setTagSetter}
            setTagExtension={setTagExtension}
            setTagPhoto={setTagPhoto}
            style={optionButtonStyle}
          />
        )}
        {deviceInfo.isMobile && props.showVideo && (
          <MobileCamera
            label={t("photoSelectModal.fromVideo")}
            onFromVideo={props.onFromVideo}
            circle={circle}
            containerWidth={containerWidth}
            containerHeight={containerHeight}
            type="video"
            isMobile={deviceInfo.isMobile}
            isTablet={deviceInfo.isTablet}
            isPortrait={deviceInfo.isPortrait}
            includeTag={includeTag}
            setSrc={setSrc}
            setTagSetter={setTagSetter}
            setTagExtension={setTagExtension}
            setTagVideo={setTagVideo}
            style={optionButtonStyle}
          />
        )}
        <FileUploader
          label={t("photoSelectModal.fromGallery")}
          accept={props.accept}
          onFromGallery={props.onFromGallery}
          circle={circle}
          containerWidth={containerWidth}
          containerHeight={containerHeight}
          isMobile={deviceInfo.isMobile}
          isTablet={deviceInfo.isTablet}
          isPortrait={deviceInfo.isPortrait}
          includeTag={includeTag}
          setTagSetter={setTagSetter}
          setSrc={setSrc}
          setTagExtension={setTagExtension}
          setTagGallery={setTagGallery}
          style={optionButtonStyle}
        />
        {props.currentPhoto && (
          <PhotoOptionButton
            onClick={() => {
              setImagePreview(props.currentPhoto);
              setImageExtension(currentPhotoExtension);
              setOpenPreview(true);
            }}
          >
            {t("photoSelectModal.crop")}
          </PhotoOptionButton>
        )}
        {props.currentPhoto && openPreview && (
          <ImagePreview
            imagePreview={imagePreview}
            imageExtension={imageExtension}
            setOpenPreview={setOpenPreview}
            setImagePreview={setImagePreview}
            setImageExtension={setImageExtension}
            setTagSetter={setTagSetter}
            setSrc={setSrc}
            setTagExtension={setTagExtension}
            setTagPhoto={setTagPhoto}
            setTagVideo={setTagVideo}
            setTagGallery={setTagGallery}
            closePhoto={closePhoto}
            {...props}
          />
        )}
        {props.showDeleteButton && (
          <PhotoOptionButton
            className="danger"
            onClick={() => {
              props.onDeleteButtonClick && props.onDeleteButtonClick();
            }}
          >
            {t("photoSelectModal.delete")}
          </PhotoOptionButton>
        )}
        </PhotoInfoCard>
      </Modal.Body>
    </StyledPhotoModal>
  );
};

const ImageButtonContainer = (props) => {
  const {
    show3D,
    button3dClick,
    disabled3D,
    deviceInfo,
    pluginSubscriptions,
    includeTag,
    circle,
    containerWidth,
    containerHeight,
    handleDeleteImageClick,
    currentPhoto,
    onFromCamera,
    onFromGallery,
    accept,
  } = props;
  const [openPreview, setOpenPreview] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const [imageExtension, setImageExtension] = useState(null);
  const [openCamera, setOpenCamera] = useState(false);
  const [tagSetter, setTagSetter] = useState(false);
  const [tagPhoto, setTagPhoto] = useState(false);
  const [tagVideo, setTagVideo] = useState(false);
  const [tagGallery, setTagGallery] = useState(false);
  const [src, setSrc] = useState(null);
  const [tagExtension, setTagExtension] = useState(null);
  const [fileUploaderClick, setFileUploaderClick] = useState(null); // State to store the handleClick function
  const [mobileCameraClick, setMobileCameraClick] = useState(null);

  const handleMobileCameraClick = () => {
    if (mobileCameraClick) {
      mobileCameraClick(); // Trigger the MobileCamera's file input click
    }
  };

  let currentPhotoExtension =
    currentPhoto && currentPhoto.indexOf("data:image/") > -1
      ? "png"
      : currentPhoto && currentPhoto.split(".").pop();

  const handleBootstrapImageClick = () => {
    if (fileUploaderClick) {
      fileUploaderClick();
    }
  };

  const { t } = useTranslation();

  return (
    <>
      <SectionLayoutType big style={{ marginTop: "20px" }}>
        <ButtonImagetype
          left
          type="button"
          onClick={() => {
            if (!deviceInfo.isMobile && !openCamera) {
              setOpenCamera(true);
            }
            if (deviceInfo.isMobile) {
              handleMobileCameraClick();
            }
          }}
        >
          <CameraFill style={{ fontSize: "25px", color: "#00197B" }} />
        </ButtonImagetype>
        <ButtonImagetype
          type="button"
          onClick={() => {
            handleBootstrapImageClick();
          }}
        >
          <BootstrapImage style={{ fontSize: "25px", color: "#00197B" }} />
        </ButtonImagetype>
        <ButtonImagetype
          type="button"
          onClick={() => {
            setImagePreview(currentPhoto);
            setImageExtension(currentPhotoExtension);
            setOpenPreview(true);
          }}
        >
          <Crop style={{ fontSize: "25px", color: "#00197B" }} />
        </ButtonImagetype>
        {pluginSubscriptions.indexOf("BOWLING_DATABASE") >= 0 && (
          <ButtonImagetype
            type="button"
            onClick={button3dClick}
            disabled={disabled3D}
            style={{
              fontSize: "25px",
              color: disabled3D ? "#cccccc" : "green",
              opacity: disabled3D ? 0.5 : 1,
              cursor: disabled3D ? "not-allowed" : "pointer",
            }}
            title={disabled3D ? "Layout data incomplete" : "Toggle 3D view"}
          >
            {show3D ? <Badge3dFill /> : <Badge3d />}
          </ButtonImagetype>
        )}
        <ButtonImagetype right type="button" onClick={handleDeleteImageClick}>
          <XSquareFill style={{ fontSize: "25px", color: "red" }} />
        </ButtonImagetype>
      </SectionLayoutType>
      {!deviceInfo.isMobile && openCamera &&
        ReactDOM.createPortal(
          <Camera
            circle={false}
            onCapture={async (
              base64,
              { containerWidth, containerHeight, circleWidth },
            ) => {
              setImagePreview(base64);
              setImageExtension("png");
              setOpenPreview(true);
              setOpenCamera(false);
            }}
            onClose={() => {
              setOpenCamera(false);
            }}
            deviceInfo={props.deviceInfo}
          />,
          document.body
        )}
      {deviceInfo.isMobile && (
        <MobileCamera
          display={false}
          label={t("photoSelectModal.fromCamera")}
          onFromCamera={onFromCamera}
          circle={circle}
          containerWidth={containerWidth}
          containerHeight={containerHeight}
          type="image"
          isMobile={deviceInfo.isMobile}
          isTablet={deviceInfo.isTablet}
          isPortrait={deviceInfo.isPortrait}
          includeTag={includeTag}
          setSrc={setSrc}
          setTagSetter={setTagSetter}
          setTagExtension={setTagExtension}
          setTagPhoto={setTagPhoto}
          onTriggerClick={setMobileCameraClick}
        />
      )}
      <FileUploader
        label={t("photoSelectModal.fromGallery")}
        style={{ display: "none" }}
        accept={accept}
        onFromGallery={onFromGallery}
        circle={circle}
        containerWidth={containerWidth}
        containerHeight={containerHeight}
        isMobile={deviceInfo.isMobile}
        isTablet={deviceInfo.isTablet}
        isPortrait={deviceInfo.isPortrait}
        includeTag={includeTag}
        setTagSetter={setTagSetter}
        setSrc={setSrc}
        setTagExtension={setTagExtension}
        setTagGallery={setTagGallery}
        onTriggerClick={setFileUploaderClick}
      />
      {openPreview && (
        <ImagePreview
          imagePreview={imagePreview}
          imageExtension={imageExtension}
          setOpenPreview={setOpenPreview}
          setImagePreview={setImagePreview}
          setImageExtension={setImageExtension}
          closePhoto={closePhoto}
          {...props}
        />
      )}
    </>
  );
};

const PhotoSelect = (props) => {
  const [openPreview, setOpenPreview] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const [imageExtension, setImageExtension] = useState(null);
  const [openCamera, setOpenCamera] = useState(false);
  const [openVideo, setOpenVideo] = useState(false);
  const [tagSetter, setTagSetter] = useState(false);
  const [tagPhoto, setTagPhoto] = useState(false);
  const [tagVideo, setTagVideo] = useState(false);
  const [tagGallery, setTagGallery] = useState(false);
  const [src, setSrc] = useState(null);
  const [tagExtension, setTagExtension] = useState(null);
  const { deviceInfo, circle, includeTag } = props;
  console.log("Props in PhotoSelect:", props);

  const { t } = useTranslation();

  const SetTagModal = (src, extension) => {
    const [tagValue, setTagValue] = useState("");
    const handleTagValue = (e) => {
      setTagValue(e);
    };

    const handleTagSubmit = () => {
      if (validateValue(tagValue) !== "") {
        if (props.onFromVideo && tagVideo) {
          props.onFromVideo(
            src.src,
            src.extension,
            tagValue.split(" ").join("-"),
          );
        } else if (props.onFromGallery && tagGallery) {
          props.onFromGallery(
            src.src,
            src.extension,
            tagValue.split(" ").join("-"),
          );
        } else if (props.onFromCamera && tagPhoto) {
          props.onFromCamera &&
            props.onFromCamera(
              src.src,
              src.extension,
              tagValue.split(" ").join("-"),
            );
        }

        setTagValue("");
        setImageExtension(null);
        setImagePreview(null);
        setTagGallery(false);
        setTagPhoto(false);
        setTagVideo(false);
        setTagSetter(false);
      }
    };
    return (
      <StyledPhotoModal
        show={tagSetter}
        centered
        size="sm"
        onHide={() => {
          setTagSetter(false);
        }}
      >
        <Modal.Header closeButton>
          <PhotoModalTitle>{t("Add Tag")}</PhotoModalTitle>
        </Modal.Header>
        <Modal.Body>
          <PhotoInfoCard>
            <AutoCompleteTag
              id="tagName"
              options={[
                { value: t("Back") },
                { value: t("Release") },
                { value: t("Revs") },
                { value: t("Side") },
              ]}
              defaultValue={tagValue}
              style={{ width: "100%" }}
              placeholder={t("form.label.tag")}
              filterOption={(inputValue, option) =>
                option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !==
                -1
              }
              name="tag"
              onChange={(e) => handleTagValue(e)}
              getPopupContainer={(triggerNode) => triggerNode.parentNode}
            />
            <ButtonAdd onClick={handleTagSubmit} style={{ width: "100%", marginTop: 12 }}>
              {t("Add Tag")}
            </ButtonAdd>
          </PhotoInfoCard>
        </Modal.Body>
      </StyledPhotoModal>
    );
  };

  return (
    <>
      <PhotoSelectModal
        {...props}
        show={!openCamera && !openPreview && !openVideo && !tagSetter && props.show}
        setOpenCamera={setOpenCamera}
        setOpenVideo={setOpenVideo}
        setTagSetter={setTagSetter}
        setSrc={setSrc}
        setTagExtension={setTagExtension}
        setTagPhoto={setTagPhoto}
        setTagVideo={setTagVideo}
        setTagGallery={setTagGallery}
        onHide={() => props.onHide()}
      />
      {!deviceInfo.isMobile && openCamera &&
        ReactDOM.createPortal(
          <Camera
            circle={false}
            onCapture={async (
              base64,
              { containerWidth, containerHeight, circleWidth },
            ) => {
              setImagePreview(base64);
              setImageExtension("png");
              setOpenPreview(true);
              setOpenCamera(false);
            }}
            onClose={() => {
              setOpenCamera(false);
            }}
            deviceInfo={props.deviceInfo}
          />,
          document.body
        )}
      {!deviceInfo.isMobile && openVideo &&
        ReactDOM.createPortal(
          <VideoCamera
            onClose={() => {
              setOpenVideo(false);
            }}
            onCapture={(url) => {
              setOpenVideo(false);
              setImageExtension("mp4");
              if (includeTag) {
                setSrc(url);
                setTagSetter(true);
                setTagVideo(true);
                setTagExtension("mp4");
              } else {
                props.onFromVideo && props.onFromVideo(url, "mp4");
              }
            }}
            deviceInfo={props.deviceInfo}
          />,
          document.body
        )}
      {openPreview && (
        <ImagePreview
          imagePreview={imagePreview}
          imageExtension={imageExtension}
          setOpenPreview={setOpenPreview}
          setImagePreview={setImagePreview}
          setImageExtension={setImageExtension}
          setTagSetter={setTagSetter}
          setSrc={setSrc}
          setTagExtension={setTagExtension}
          setTagPhoto={setTagPhoto}
          setTagVideo={setTagVideo}
          setTagGallery={setTagGallery}
          closePhoto={closePhoto}
          {...props}
        />
      )}
      {tagSetter && (
        <SetTagModal
          src={src}
          extension={tagExtension}
          setTagSetter={setTagSetter}
        />
      )}
    </>
  );
};
export const ConnectedImageButtonContainer = connect(
  (state) => ({
    deviceInfo: state.userSession.deviceInfo,
    pluginSubscriptions: state.plugin.pluginSubscriptions,
  }),
  {},
)(ImageButtonContainer);

export default connect(
  (state) => ({
    deviceInfo: state.userSession.deviceInfo,
  }),
  { closePhoto, openPhoto },
)(PhotoSelect);
